<template>
  <!-- Mobile Navigation Drawer  -->
  <v-navigation-drawer
    v-if="isAuthenticated && !$route.meta.public"
    v-model="mobileDrawer"
    class="pb-0 nav-drawer"
    height="100%"
    fixed
    temporary
  >
    <!-- v-click-outside="closeMobileDrawer" -->
    <v-list dense>
      <div class="logo-container">
        <img class="logo" :src="E6Logo" alt="E6 Logo" />
      </div>
      <v-list-item class="avatar-tile" @click="routeTo(`/users/${meID}`)">
        <v-list-item-avatar>
          <v-img
            v-if="profileImage && profileImage.imageURL"
            :src="`${profileImage.imageURL}?w=200&h=200&fit=crop`"
            alt="User Profile Image"
            :lazy-src="lazyProfileImage"
          />
        </v-list-item-avatar>
        <v-list-item-title v-if="displayName" class="username">
          {{ displayName }}
        </v-list-item-title>
      </v-list-item>

      <template v-for="(item, i) in filteredMobileMenu">
        <template v-if="!item.children">
          <v-list-item :key="i" @click="routeTo(item.to)">
            <v-list-item-action class="menu-item">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>

      <v-divider class="left-nav-divider"></v-divider>

      <div v-if="!limitedUser">
        <v-list-group
          v-for="item in mobileSubMenu"
          :key="item.title"
          :prepend-icon="item.icon"
          :value="item.active"
        >
          <v-list-item slot="activator" class="pl-0">
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="subItem in item.children"
            :key="subItem.title"
            @click="routeTo(subItem.to)"
          >
            <v-list-item-content>
              <v-list-item-title class="subItem">{{ subItem.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </div>
      <v-list-item v-if="canViewAdmin" @click.stop="changeAdmin">
        <v-list-item-action class="menu-item">
          <v-icon>lock</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Admin</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="canViewPartnerAdmin" @click.stop="changePartner">
        <v-list-item-action class="menu-item">
          <v-icon>handshake</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Partner</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="logout">
        <v-list-item-action class="menu-item">
          <v-icon>exit_to_app</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t('nav.logout') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- //* Alternate language switcher -->
      <!-- <v-list-tile style="cursor: pointer">
          <v-list-tile-action class="menu-item">
            <v-icon>language</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-dialog v-model="mobileLocaleDialog" width="300">
              <template v-slot:activator="{ on }">
                <v-list-tile-title v-on="on">{{ $t('nav.lang') }}</v-list-tile-title>
              </template>

              <v-card>
                <v-card-text>Please choose your language:</v-card-text>
                <v-flex xs12>
                  <LocaleSwitcher />
                </v-flex>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="mobileLocaleDialog = false"> close </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-list-tile-content>
        </v-list-tile> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
// @ PROPS =========
// @ me
// @ drawer
// @ isAuthenticated
// @ canViewAdmin
// @ limitedUser
// @ routeTo - method
// @ changeAdmin - method
// @ logout - method
// @ closeMobileDrawer - method

import E6Logo from '@/assets/E6_Cube.png';
import ClickOutsideDirective from '@/directives/ClickOutside.directive';
import { isDev } from '@/utils/helpers';

export default {
  name: 'AppMobileNavDrawer',

  directives: {
    'click-outside': ClickOutsideDirective,
  },
  props: {
    me: {
      type: Object,
      required: true,
    },
    clubhouse: {
      type: Object,
      required: true,
    },
    dashboardLink: {
      type: String,
      required: true,
    },
    drawer: {
      type: Boolean,
      required: true,
      default: false,
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    canViewAdmin: {
      type: Boolean,
      default: false,
    },
    hasReseller: {
      type: Boolean,
      default: false,
    },
    limitedUser: {
      type: Boolean,
      default: false,
    },
    isPartner: {
      type: Boolean,
      required: true,
    },
    canViewPartnerAdmin: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      E6Logo,
      isDev,
      lazyProfileImage:
        'https://e6golf-qa-assets.imgix.net/shared/player-art/chipped.jpg?h=200&w=200&fit=crop',
    };
  },

  computed: {
    mobileDrawer: {
      get() {
        return this.drawer;
      },
      set(val) {
        this.$emit('setDrawerValue', val);
        return val;
      },
    },

    meID() {
      const meID = this.getMe?.id ? this.getMe.id : undefined;
      return meID;
    },

    profileImage() {
      return this.me?.profileImage ? this.me?.profileImage : '';
    },

    displayName() {
      return this.me?.displayName ? this.me?.displayName : '';
    },

    mobileMenu() {
      let menu = [];
      const meID = this.getMe?.id ? this.getMe.id : this.me?.id ? this.me.id : 'undefined';

      if (meID) {
        menu = [
          { title: `${this.$t('nav.dashboard')}`, to: `/users/${meID}`, icon: 'home' },
          this.clubhouse?.id
            ? {
                title: `${this.$t('nav.myClubhouse')}`,
                to: {
                  path: `/clubhouse/${this.dashboardLink}/dashboard`,
                  props: true,
                  name: this.dashboardLink === 's' ? 'clubhouses' : 'clubhouseDashboard',
                  params: {
                    clubhouseID: this.dashboardLink,
                    clubhouse: this.clubhouse,
                  },
                },
                icon: 'dashboard',
              } //* This route works to route appropriately
            : { title: `${this.$t('nav.clubhouses')}`, to: '/clubhouses', icon: 'contacts' },
          this.clubhouse?.id
            ? { title: `${this.$t('nav.allClubhouses')}`, to: '/clubhouses', icon: 'contacts' }
            : null,
          // { title: 'Events', to: '/events', icon: 'event' }, //* Full Event List
          { title: `${this.$t('nav.events')}`, to: `/users/${meID}/events`, icon: 'event' }, //* User Events
          {
            title: `${this.$t('nav.seasons')}`,
            to: `/users/${meID}/seasons`,
            icon: 'account_tree',
          }, //* User Seasons
          !this.limitedUser ? { title: `${this.$t('nav.shop')}`, to: '/shop', icon: 'shop' } : null,
          this.isDev()
            ? {
                title: `${this.$t('nav.analytics')}`,
                to: `/users/${meID}/analytics`,
                icon: 'analytics',
              }
            : null, //* Shot analytics
          // { title: 'Analytics', to: '/analytics', icon: 'analytics' }, //* Shot analytics
          {
            title: `${this.$t('nav.downloads')}`,
            to: `/update/e6-connect`,
            icon: 'cloud_download',
          },
          {
            title: `${this.$t('settingsNav.settings')}`,
            to: '/settings',
            icon: 'settings',
            children: [
              { text: `${this.$t('settingsNav.editProfile')}`, to: '/settings/profile' },
              { text: `${this.$t('settingsNav.account')}`, to: '/settings/account' },
              { text: `${this.$t('settingsNav.licenses')}`, to: '/settings/licenses' },
              { text: `${this.$t('settingsNav.orderhistory')}`, to: '/settings/history' },
              { text: `${this.$t('settingsNav.preferences')}`, to: '/settings/preferences' },
            ],
          },
        ];
      }

      return menu;
    },

    mobileSubMenu() {
      return this.mobileMenu?.filter((item) => {
        return item?.children;
      });
    },

    filteredMobileMenu() {
      return this.mobileMenu.filter((item) => {
        return item !== null && item?.to !== undefined;
      });
    },
  },

  methods: {
    logout() {
      this.$emit('logout');
    },

    routeTo(data) {
      this.$emit('routeTo', data);
    },

    changeAdmin() {
      this.$emit('changeAdmin');
    },

    changePartner() {
      this.$emit('changePartner');
    },

    closeMobileDrawer() {
      this.$emit('closeMobileDrawer');
    },
  },
};
</script>

<style scoped></style>
